import scheme from '../scheme/scheme.js'

export default () => {
  return {

    // Inspi Viewer Component
    source: scheme.inspiViewerSource,
    version: scheme.inspiViewerVersion,
    user: 'hbm-website',
    token: 'K2%Hv5uc',

    // Product
    productLoaded: false,
    productName: null,
    productPrice: null,
    configurationCode: null,
    configurationSummary: null,

    // UI
    menuDisplayed: true,
    dividersDisplayed: true,
    collectionDisplayed: false,

    // Header
    headerAlignment: 'left',
    productNameDisplayed: false,
    productPriceDisplayed: false,

    // Gamepad
    gamepadButtonsColor: '005686',
    arButtonDisplayed: true,
    resetButtonDisplayed: true,
    dimensionsButtonDisplayed: true,
    screenshotButtonDisplayed: false,
    projectButtonDisplayed: false,
    configurationSummaryDisplayed: false,

    // Screenshot
    frontScreenshotEnabled: false,
  }
}